import { SignInSource } from 'src/components/SignIn/SignIn';
import { EmailRequiredOptions } from './WizardTracking';

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

window.dataLayer = window.dataLayer || [];
export const trackEmailPromptShown = (
  location: string,
  is_email_required: EmailRequiredOptions,
): void => {
  window.dataLayer.push({
    event: 'email_prompt_shown',
    location,
    is_email_required,
  });
};
export const trackEmailPromptCompleted = (
  location: string,
  is_email_required: EmailRequiredOptions,
): void => {
  window.dataLayer.push({
    event: 'email_prompt_completed',
    location,
    is_email_required,
  });
};
export const trackSignInStatus = ({
  userId,
  status,
  source,
}: {
  userId?: string;
  status: 'SUCCESS' | 'FAILURE';
  source?: SignInSource;
}): void => {
  window.dataLayer.push({
    event: 'sign_in_status',
    userId,
    status,
    source,
  });
};

export const trackMarketingConsentAcceptance = ({
  userId,
  status,
  source,
}: {
  userId?: string;
  status: 'CONSENTED' | 'REJECTED' | 'ALREADY_CONSENTED';
  source?: SignInSource;
}): void => {
  window.dataLayer.push({
    event: 'sign_in_marketing_consent',
    userId,
    status,
    source,
  });
};

export const trackSignedUpForNewsletter = ({
  userId,
  source,
}: {
  userId?: string;
  source?: SignInSource;
}): void => {
  window.dataLayer.push({
    event: 'signed_up_for_newsletter',
    userId,
    source,
  });
};

export const trackEmailPromptSkipped = (
  location: string,
  is_email_required: EmailRequiredOptions,
): void => {
  window.dataLayer.push({
    event: 'email_prompt_skipped',
    location,
    is_email_required,
  });
};
